<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">视频认证</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证总状态：</label>
          <el-select v-model="overallAuthState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in overallAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>vip类型：</label>
          <el-select v-model="vipState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in vipStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
<!--          <el-button type="primary" v-loading="updateLoading" @click="updateReadState">已查看</el-button>-->
          <ElButtons icon="Comment" @click="sendSysMsg">发送通知</ElButtons>
          <el-button type="primary" @click="updateSpecial">专区操作</el-button>
          <el-button v-show="state != 2" type="success" @click="batchPass" v-loading="passLoading">批量通过</el-button>
          <el-button v-show="state != 3" type="danger" @click="batchReject">批量不通过</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
            @selection-change="selsChange"
            @header-click="selsAll"
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="updateTime" label="更新时间" v-if="checkColList.indexOf('更新时间') > -1"/>
          <el-table-column property="" label="专区类型" v-if="checkColList.indexOf('专区类型') > -1" min-width="90">
            <template #default="scope">
              <p v-for="(item, index) in scope.row.specialsUserList" :key="index" style="margin: 8px 0;">
                <span style="color: #409eff; cursor: pointer;" @dblclick="removeSpecialUser(scope.$index,index)">{{ item.name }}</span>
                {{ item.isShow==1?'(外展)':'' }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" min-width="105">
            <template #default="scope">
              <HeadImg :images="scope.row.headImg" />
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" min-width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city,birth"/>
            </template>
          </el-table-column>
          <el-table-column label="身份证照片" v-if="checkColList.indexOf('身份证照片') > -1" min-width="192">
            <template #default="scope">
              <el-space>
                <GetPlain :side="0" :url="scope.row.identityAuth.imgF" :uid="scope.row.uid" :type="12" :subType="0"/>
                <GetPlain :side="1" :url="scope.row.identityAuth.imgZ" :uid="scope.row.uid" :type="12" :subType="0"/>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column label="身份认证总状态" v-if="checkColList.indexOf('身份认证总状态') > -1" min-width="130">
            <template #default="scope">
              <p>{{scope.row.identityAuth.overallAuthState == 0 ? "未提交" : scope.row.identityAuth.overallAuthState == 1 ? "待审核" : scope.row.identityAuth.overallAuthState == 2 ? "审核通过" : scope.row.identityAuth.overallAuthState == 3 ? "审核不通过" : ""}}</p>
            </template>
          </el-table-column>
          <el-table-column label="视频" v-if="checkColList.indexOf('视频') > -1" width="130">
            <template #default="scope">
              <i class="fa fa-play-circle fa-4x playBtn" aria-hidden="true" @click="onPlay(scope.$index, scope.row)"></i>
            </template>
          </el-table-column>
          <el-table-column label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <span>{{scope.row.state==1?'待审核':scope.row.state==2?'已通过':scope.row.state==3?'不通过':''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import {
  delUserSpecials,
  getAuthVideoPageList,
  updateAdviceReadState,
  delAuthEduData,
  bathUpdateAuthVideo
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import SendSystemMessage from "@/components/SendSystemMessage";
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import {common, auth} from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import GetPlain from "@/components/resume/GetPlain";
import EducationDialog from "@/views/auth/components/EducationDialog";
import AuthSpecialDialog from "./components/AuthSpecialDialog";
import VideoAuthDialog from "./components/VideoAuthDialog";
import VideoRejectDialog from "@/views/auth/components/VideoRejectDialog";

export default {
  name: "AuthVideo",
  components: { DatePickerRange, SearchComponents, UserLog, GetPlain },
  data() {
    return {
      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      overallAuthStateArray: auth.overallAuthStateList,
      overallAuthState: auth.overallAuthStateList[0]['value'],

      vipStateArray: auth.videoStateList,
      vipState: auth.eduList[0]['value'],

      stateArray: [
        {label:"不限",value:-1},
        {label:"待审核",value:1},
        {label:"已通过",value:2},
        {label:"不通过",value:3},
      ],
      state: 1,

      passLoading: false,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '身份证号', value : 4}
      ],
      searchType: 2,
      searchValue: '',

      //刷新组
      colList: ['更新时间','专区类型', '头像', '用户信息', '身份证照片', '身份认证总状态', '视频', '状态', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      //选中id
      idArray: [],
      userIdArray: [],
      //选中性别
      userSexArray: [],

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      this.overallAuthState = -1;
      this.vipState = -1;
      this.state = 1;
      this.startTime = '';
      this.endTime = '';
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
      this.userIdArray = sels.map(item => item.userId);
      this.userSexArray = sels.map(item => item.sex);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['overallAuthState'] = this.overallAuthState;
      param['vipState'] = this.vipState;
      param['state'] = this.state;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getAuthVideoPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    // updateReadState() {
    //   if(this.idArray.length > 0) {
    //     this.$confirm('确认批量处理为【已查看】').then(()=>{
    //       this.updateLoading = true;
    //       let _this = this;
    //       let param = {};
    //       param['ids'] = this.idArray;
    //       postFormData(updateAdviceReadState, param).then((data) => {
    //         let {code, msg} = data;
    //         if(code == 200) {
    //           _this.$message({
    //             showClose: true,
    //             duration: 1000,
    //             message: msg,
    //             type: 'success'
    //           });
    //           for(let j=0;j<_this.idArray.length;j++){
    //             for(let i=0;i<_this.pageDataList.length;i++) {
    //               if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
    //                 _this.pageDataList.splice(i,1);
    //                 i--;
    //               }
    //             }
    //           }
    //           if(_this.pageDataList.length == 0){
    //             _this.getPage();
    //           }
    //         }else {
    //           _this.$message({
    //             showClose: true,
    //             duration: 1000,
    //             message: msg,
    //             type: 'warning'
    //           });
    //         }
    //         _this.updateLoading = false;
    //       })
    //           .catch(()=>{
    //             _this.updateLoading = false;
    //           })
    //     })
    //   }else {
    //     this.$message({
    //       showClose: true,
    //       duration: 1000,
    //       message: '请至少选择一条记录进行操作',
    //       type: 'warning'
    //     })
    //   }
    // },

    //图片预览

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['user_log'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }


    },

    //学历认证审核
    jobDialog(idx, row){
      let educationForm = Object.assign({}, row);
      Dialog.open({
        title: '学历认证审核',
        component: EducationDialog,
        data: {
          educationForm: educationForm,
        },
        confirm: (result) => {
          this.pageDataList.splice(idx,1);
          if(this.pageDataList.length == 0){
            this.getPage();
          }
        }
      })
    },

    //发送系统消息
    sendSysMsg() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessage,
        data: {
          userIdArray: this.userIdArray,
          width: '600px'
        },
        confirm: () => {

        }
      })
    },

    //删除认证材料
    // delDate(idx) {
    //   this.$confirm('确认使认证材料失效？')
    //       .then(() => {
    //             this.pageDataList[idx]['delDateLoading'] = true;
    //             let param = {};
    //             param['id'] = this.pageDataList[idx]['id'];
    //             param['userId'] = this.pageDataList[idx]['userId'];
    //             param['isDel'] = 1;
    //             let _this = this;
    //             postFormData(delAuthEduData, param).then((data) => {
    //               let { msg, code } = data;
    //               if(code == 200) {
    //                 _this.$message({
    //                   showClose: true,
    //                   duration: 1000,
    //                   message: msg,
    //                   type: 'success'
    //                 })
    //                 _this.pageDataList.splice(idx,1);
    //               } else{
    //                 _this.$message({
    //                   showClose: true,
    //                   duration: 1000,
    //                   message: msg,
    //                   type: 'warning'
    //                 })
    //               }
    //               _this.pageDataList[idx]['delDateLoading'] = false;
    //             })
    //                 .catch((data) => {
    //                   _this.pageDataList[idx]['delDateLoading'] = false;
    //                 })
    //           }
    //       )
    //       .catch(() => {})
    // },

    //取消专区
    removeSpecialUser(userIdx, specialIdx) {
      this.$confirm('请确认是否继续移除操作', {
        type: 'warning'
      }).then(() => {
        let _this = this;
        let param = {};
        param['userId'] = this.pageDataList[userIdx]['userId'];
        param['specialsId'] = this.pageDataList[userIdx]['specialsUserList'][specialIdx]['id'];
        postFormData(delUserSpecials, param).then(function(data) {
          let {
            code,
            msg
          } = data;
          if(code == 200) {
            _this.pageDataList[userIdx]['specialsUserList'].splice(specialIdx, 1);
            _this.$message({
              showClose: true,
              duration: 1000,
              message: '操作成功',
              type: 'success'
            });
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
        })
            .catch(function(response) {})
      })
          .catch(() => {

          })
    },

    //专区操作
    updateSpecial() {
      if(this.idArray.length > 0) {
        let s = this.userSexArray[0]
        let isSex = this.userSexArray.every((val) => {
          return val == s;
        });
        if(!isSex) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: '勾选用户性别不一致，无法进行专区操作',
            type: 'warning'
          })
          return false
        }
        Dialog.open({
          title: '专区选择',
          component: AuthSpecialDialog,
          data: {
            idArray: this.userIdArray,
            sex: s,
            width: '500px'
          },
          confirm: () => {
            this.getPage();
          }
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
      }
    },

    onPlay(idx, row) {
      Dialog.open({
        title: '视频审核',
        component: VideoAuthDialog,
        data: {
          videoForm: row,
        },
        confirm: () => {
          this.pageDataList.splice(idx,1);
        }
      })
    },

    //提交
    batchPass() {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量通过选中的视频认证？').then(() => {
          this.passLoading = true;
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray;
          param['state'] = 2;
          param['warnMsg'] = '';
          postFormData(bathUpdateAuthVideo,param).then(function(data){
            let {code,msg} = data;
            if(code == 200){
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++) {
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0) {
                _this.getPage(false);
              }
            }else{
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            _this.passLoading = false;
          })
              .catch(function(response){
                _this.passLoading = false;
              })
        })
            .catch(() => {})
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
      }
    },

    batchReject() {
      if(this.idArray.length > 0) {
        Dialog.open({
          title: '编辑发送视频不通过原因',
          component: VideoRejectDialog,
          data: {
            ids: this.idArray,
            width: '500px'
          },
          confirm: () => {
            for(let j=0;j<this.idArray.length;j++) {
              for(let i=0;i<this.pageDataList.length;i++) {
                if(this.pageDataList[i]['id'] == this.idArray[j]) {
                  this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(this.pageDataList.length == 0) {
              this.getPage(false);
            }
          }
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
      }
    }



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
.playBtn {
  font-size: 5em;
  color: #c0c4cc;
  cursor: pointer;
}
.playBtn:hover {
  font-size: 5em;
  color: #3a8ee6;
}
</style>
